import { Helmet } from "react-helmet-async";
import NavbarTop from "../../components/NavbarTop";
import { useEffect, useRef, useState, useCallback } from "react";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import PostList from "../../components/Post/PostList";
import { useAuth, useMessage } from "../../global-components/src";
import { useNavigate, useParams } from "react-router-dom";
import "./style.css"
import ModalPostLikes from "../Posts/PostLikes/ModalPostLikes";
// import ModalPostComments from "../Posts/PostLikes/ModalPostComments";
import { getViewedAds, updateViewedAds } from "../../utils/ads";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import ModalCommentsBottom from "../../components/Modals/comments/comments-bottom";
import { PostLoading } from "../../components/Post/post-loading";
import ModalComments from "../../components/Modals/comments/modal-comments";
import { useTranslation } from 'react-i18next';

const HiddenPosts: React.FC = () => {
    const [posts, setPosts] = useState<any[]>([]);
    const [cursor, setCursor] = useState<number | null>(null);
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(1);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [feedType, setFeedType] = useState("feed");
    const [error, setError] = useState("");
    const { user, token } = useAuth();
    const userImg = user?.img_account ? BUCKET_PACOCA_URL + "/" + user?.img_account.replace(/\.\.\//g, '') : "/img/img-account.png";
    const hasRun = useRef(false);
    const { hashtag } = useParams();
    const [idPostSelected, setIdPOstSelected] = useState<number | null>(null)
    const [show, setShow] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const { setMessage } = useMessage();
    const { t } = useTranslation();


    const loadPosts = async (cursorParam: number | null = cursor) => {
        // anuncios já vistos
        const viewedAds = getViewedAds();
        const viewedAdsParam = viewedAds.join(',');
        let url = `${PACOCA_API_URL}/posts?feedType=hidden&hide_ads=1`;

        if(cursorParam){
            url += `&cursor=${cursorParam}`;
        }

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            
            const data = response.data.posts;
            setCursor(response.data.next_cursor);

            if (data.length > 0) {
                setPosts((prev) => {
                    const existingIds = new Set(prev.map(post => post?.id)); // Cria um Set com os IDs existentes
                    const newPosts = data.filter((post: { id: any; }) => !existingIds.has(post?.id)); // Filtra apenas posts novos
                    if (newPosts.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
                    const updatedPosts = [...prev, ...newPosts];
                    updateViewedAds(data);
                    return updatedPosts;
                });
            } else {
                setEnd(true);
            }
            
        } catch (err: any) {
            console.error("Failed to load posts:", err);
            setEnd(true);
            if(err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "warning")
        } finally {
            setLoading(false);
        }
    };

    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting && !loading && !end) {
                setPage((prev) => prev + 1);
            }
        },
        [loading, end]
    );

    useEffect(() => {
        if (!hasRun.current || page != 1) {
            loadPosts(cursor);
            // Salva a página atual no localStorage
            sessionStorage.setItem('page', page.toString());
            hasRun.current = true;

        }
    }, [page, feedType]);

    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

    useEffect(() => {
        // Salva a posição de rolagem quando o feed for modificado
        const handleScroll = () => {
            sessionStorage.setItem("scrollPosition", window.scrollY.toString());
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleModalClose = () => {
            setShow(false)
            setShowModalComments(false)
            setIdPOstSelected(null)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    return (
        <div className="container container-feed" style={{ paddingTop: "60px", minWidth: "100%!important", minHeight: "100dvh" }}>
            <Helmet>
                <title>Paçoca</title>
                <meta name="author" content="Paçoca Inc."/>
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:type" content="website"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
            </Helmet>

            <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-4" style={{position: "relative"}}>
                    <NavbarTop title="Posts ocultos pelo Paçoca AI"/>

                    <div className="postlist-hashtag">
                        <PostList onOpenComments={(idPost) => {setShowModalComments(true); setIdPOstSelected(idPost);}} onOpenLikes={(idPost) => {setShow(true); setIdPOstSelected(idPost)}} posts={posts} setPosts={setPosts}/>

                        <div ref={endOfListRef} style={{ height: "20px" }}></div>

                        <PostLoading loading={loading}/>

                        {end && (
                            <div style={{ textAlign: "center", marginTop: "20px", display: "flex", justifyContent: "center" }}>
                                <div id="text-carregar" style={{ textAlign: "center", marginTop: "20px" }}>
                                    Fim do Feed
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <ModalPostLikes idPostSelected={idPostSelected} show={show} />
            {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={idPostSelected}/> : <ModalComments idPostSelected={idPostSelected} show={showModalComments} />}
        </div>
    );
};

export default HiddenPosts;
